import React from "react";
import {formatSignedPercent, TREND_DOWN_COLOR, TREND_NEUTRAL_COLOR, TREND_UP_COLOR} from "./format.js";

/**
 * Abweichungswert mit Vorzeichen und dezenter Farbe (nie Farbe allein als
 * Informationsträger, siehe formatSignedPercent in Components/Statistics/
 * format.js). Fehlt der Wert (Division durch 0), erscheint der neutrale
 * Platzhalter "–".
 */
export default function SignedPercentValue({value, decimals = 1}) {
    const formatted = formatSignedPercent(value, decimals);
    if (formatted === null) {
        return <span className="text-muted">–</span>;
    }
    const color = value > 0 ? TREND_UP_COLOR : value < 0 ? TREND_DOWN_COLOR : TREND_NEUTRAL_COLOR;
    return <span style={{color}}>{formatted}</span>;
}
